const fr = {
  // Navigation
  nav: {
    home: 'Accueil',
    about: 'À Propos',
    experience: 'Expérience',
    projects: 'Projets',
    contact: 'Contact',
  },

  // Section Hero
  hero: {
    greeting: 'Spécialiste en Cybersécurité',
    titles: ['Spécialiste en Cybersécurité', 'Analyste SOC Niveau 1', 'Passionné de Hacking Éthique'],
    description: 'Automatisation de sécurité, surveillance des menaces et défense pour les systèmes modernes.',
    viewProjects: 'Voir Projets',
    downloadCV: 'Télécharger CV',
  },

  // Section À Propos
  about: {
    title: 'À Propos',
    description: 'Je m\'appelle Diogo Cunha, j\'ai 24 ans et je suis militaire dans l\'Armée de l\'Air portugaise. Je suis spécialiste en cybersécurité avec plus de 3 ans dans les opérations de défense, axé sur la surveillance, le threat hunting et l\'automatisation de la sécurité. J\'ai une solide expérience en développement Python et en sécurité réseau, et je construis des systèmes résilients ainsi que des outils pratiques. J\'ai commencé dans ce domaine grâce à ma passion pour la technologie, ce qui m\'a conduit à choisir la cybersécurité. Mon objectif est d\'apprendre un maximum et de progresser autant sur le plan professionnel que personnel.',
    stats: {
      experience: 'Années d\'Expérience',
      certifications: 'Certifications',
      projects: 'Projets de Sécurité',
    },
    highlightsTitle: 'Ce Que J\'Apporte',
    highlights: {
      securityOps: {
        title: 'Opérations de Sécurité',
        description: 'Travail pratique de défense en surveillance, investigation et réponse aux incidents avec une mentalité basée sur le risque.',
      },
      threatAnalysis: {
        title: 'Analyse des Menaces et Malware',
        description: 'Triage et analyse pour comprendre les comportements, réduire l\'exposition et améliorer les playbooks de détection et réponse.',
      },
      automation: {
        title: 'Automatisation et Outils',
        description: 'Construction d\'outils pratiques qui simplifient le travail répétitif et transforment les insights de sécurité en workflows répétables.',
      },
    },
  },

  // Section Expérience
  experience: {
    title: 'Expérience',
    subtitle: 'Mon parcours dans l\'industrie de la cybersécurité et IT',
    tabs: {
      professional: 'Professionnel',
      academic: 'Académique',
      certifications: 'Certifications',
    },
    jobs: {
      cybersecuritySpecialist: {
        title: 'Spécialiste en Cybersécurité',
        company: 'Portuguese Air Force',
        responsibilities: [
          'Analyse et Détection de Malware',
          'Évaluation des Vulnérabilités',
          'Automatisation et scripting en Python',
          'Penetration Testing',
          'Systèmes d\'exploitation et fondamentaux réseau',
        ],
      },
      complianceAnalyst: {
        title: 'Spécialiste Compliance',
        company: 'Leica Microsystems',
        responsibilities: [
          'Gestion des systèmes SAP',
          'Analyse de données Excel',
          'Rapports et documentation de compliance',
        ],
      },
      itConsultant: {
        title: 'Consultant IT',
        company: 'Inetum',
        responsibilities: [
          'Support et conseil client',
          'Intégration de systèmes',
        ],
      },
      itTechnician: {
        title: 'Technicien IT',
        company: 'Claranet',
        responsibilities: [
          'Installation d\'Équipements IT',
          'Préparation des équipements pour installation',
          'Configuration IP sur Imprimantes',
          'Configuration et mise en place d\'ordinateurs sur le réseau',
        ],
      },
    },
    education: {
      cybersecurity: {
        degree: 'Cybersécurité',
        institution: 'ISTEC',
        level: 'Technicien Niveau 5',
        description: 'Études avancées en cybersécurité, axées sur le penetration testing, la défense réseau et l\'architecture de systèmes sécurisés.',
      },
      programming: {
        degree: 'Gestion et Programmation de Systèmes Informatiques',
        institution: 'Escola Secundária Leal da Câmara',
        level: 'Qualification Niveau 4',
        description: 'Fondements en systèmes informatiques, programmation et gestion IT.',
      },
    },
    certifications: [
      { name: 'Cyber Defender Final Examination', issuer: 'MILE2', year: '2024' },
      { name: 'C)ITP: Certified Information Technology Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)SP: Certified Security Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)NP: Certified Network Principles', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-NSD: Network Security and Defense', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-IRM: Incident Response and Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-TIVM: Threat Intelligence and Vulnerability Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-FOC: Foundations of Cybersecurity', issuer: 'MILE2', year: '2024' },
      { name: 'Ethical Hacking Essentials (EHE)', issuer: 'EC-Council', year: '2022' },
      { name: 'Digital Forensics Essentials (DFE)', issuer: 'EC-Council', year: '2023' },
    ],
  },

  // Section Projets
  projects: {
    title: 'Projets en Vedette',
    subtitle: 'Outils de sécurité, automatisation et travaux d\'ingénierie sélectionnés.',
    featured: 'En Vedette',
    items: {
      blueTeam: {
        title: 'Scripts de Défense Blue Team',
        description: 'Collection de scripts Python conçus pour la surveillance et les opérations de défense en cybersécurité. Outils automatisés pour la détection des menaces, l\'analyse des logs et la réponse aux incidents dans les opérations blue team.',
        overlay: 'Défense Blue Team',
      },
      carapauCracker: {
        title: 'CarapauCracker - Outil d\'Analyse de Sécurité',
        description: 'Framework avancé d\'analyse et de tests de sécurité basé sur Python. Développé pour le penetration testing et l\'évaluation des vulnérabilités avec des capacités de shell scripting automatisé.',
        overlay: 'Analyse de Sécurité',
      },
      writeUpPage: {
        title: 'Write-Up Page',
        description: 'Page dédiée à l\'organisation et à la publication de write-ups de sécurité, de défis et d\'analyses techniques. Conçue pour présenter le contenu de manière claire, structurée et facile à consulter.',
        overlay: 'Write-Ups',
      },
      sportsAnalysis: {
        title: 'Analyse Sportive',
        description: 'Une plateforme inspirée de Flashscore, mais axée sur des analyses plus poussées pour le trading sportif — statistiques détaillées et probabilités de résultat pour chaque match.',
        overlay: 'Analyse Sportive',
      },
    },
  },

  // Section Contact
  contact: {
    title: 'Contactez-Moi',
    subtitle: 'Ouvert aux projets, collaborations et rôles de sécurité.',
    infoTitle: 'Parlons!',
    infoText: 'Partagez un bref aperçu et un calendrier, et je répondrai dès que possible.',
    email: 'Email',
    location: 'Localisation',
    locationValue: 'Lisbonne / Portugal',
    form: {
      name: 'Nom',
      namePlaceholder: 'Votre nom',
      email: 'Email',
      emailPlaceholder: 'Votre email',
      message: 'Message',
      messagePlaceholder: 'Votre message',
      submit: 'Envoyer Message',
      success: 'Message envoyé avec succès! Merci de m\'avoir contacté.',
      errors: {
        nameRequired: 'Veuillez entrer votre nom',
        emailRequired: 'Veuillez entrer votre email',
        emailInvalid: 'Veuillez entrer un email valide',
        messageRequired: 'Veuillez entrer un message',
      },
    },
  },

  // Pied de page
  footer: {
    builtWith: 'Construit avec React | Portfolio de Cybersécurité',
    role: 'Spécialiste en Cybersécurité | Développeur Full Stack',
  },
};

export default fr;
